import { exportStore } from '@export/store/exportStore.ts';

const useExportStore = () => {
  const scanId = exportStore((state) => state.scanId);
  const setScanId = exportStore((state) => state.setScanId);

  const jaws = exportStore((state) => state.jaws);
  const setJaws = exportStore((state) => state.setJaws);

  const corrections = exportStore((state) => state.corrections);
  const setCorrections = exportStore((state) => state.setCorrections);

  const activeCorrectionId = exportStore((state) => state.activeCorrectionId);
  const setActiveCorrectionId = exportStore((state) => state.setActiveCorrectionId);

  const generateAlignerShell = exportStore((state) => state.generateAlignerShell);
  const setGenerateAlignerShell = exportStore((state) => state.setGenerateAlignerShell);
  const alignerStatus = exportStore((state) => state.alignerStatus);
  const setAlignerStatus = exportStore((state) => state.setAlignerStatus);

  const trimCurves = exportStore((state) => state.trimCurves);
  const trimCurveState = exportStore((state) => state.trimCurveState);
  const trimEditingJaw = exportStore((state) => state.trimEditingJaw);
  const setTrimCurve = exportStore((state) => state.setTrimCurve);
  const setTrimCurveState = exportStore((state) => state.setTrimCurveState);
  const generateTrimCurveAction = exportStore((state) => state.generateTrimCurve);
  const setGenerateTrimCurve = exportStore((state) => state.setGenerateTrimCurve);
  const confirmTrimCurveAction = exportStore((state) => state.confirmTrimCurve);
  const setConfirmTrimCurve = exportStore((state) => state.setConfirmTrimCurve);
  const cancelTrimCurveAction = exportStore((state) => state.cancelTrimCurve);
  const setCancelTrimCurve = exportStore((state) => state.setCancelTrimCurve);

  const trimThickeningActive = exportStore((state) => state.trimThickeningActive);
  const setTrimThickeningActive = exportStore((state) => state.setTrimThickeningActive);
  const trimBrushRadius = exportStore((state) => state.trimBrushRadius);
  const setTrimBrushRadius = exportStore((state) => state.setTrimBrushRadius);
  const trimSelectedPoints = exportStore((state) => state.trimSelectedPoints);
  const setTrimSelectedPoints = exportStore((state) => state.setTrimSelectedPoints);
  const trimThicknessValue = exportStore((state) => state.trimThicknessValue);
  const applyTrimThickness = exportStore((state) => state.applyTrimThickness);

  const cappingDebugVisible = exportStore((state) => state.cappingDebugVisible);
  const setCappingDebugVisible = exportStore((state) => state.setCappingDebugVisible);

  const bandVoxelDebugVisible = exportStore((state) => state.bandVoxelDebugVisible);
  const setBandVoxelDebugVisible = exportStore((state) => state.setBandVoxelDebugVisible);

  const reset = exportStore((state) => state.reset);

  return {
    scanId,
    setScanId,
    jaws,
    setJaws,
    corrections,
    setCorrections,
    activeCorrectionId,
    setActiveCorrectionId,
    generateAlignerShell,
    setGenerateAlignerShell,
    alignerStatus,
    setAlignerStatus,
    trimCurves,
    trimCurveState,
    trimEditingJaw,
    setTrimCurve,
    setTrimCurveState,
    generateTrimCurveAction,
    setGenerateTrimCurve,
    confirmTrimCurveAction,
    setConfirmTrimCurve,
    cancelTrimCurveAction,
    setCancelTrimCurve,
    trimThickeningActive,
    setTrimThickeningActive,
    trimBrushRadius,
    setTrimBrushRadius,
    trimSelectedPoints,
    setTrimSelectedPoints,
    trimThicknessValue,
    applyTrimThickness,
    cappingDebugVisible,
    setCappingDebugVisible,
    bandVoxelDebugVisible,
    setBandVoxelDebugVisible,
    reset,
  };
};

export default useExportStore;

